module.exports = __webpack_public_path__ + "img/chanping.9f3277d7.png";